import { render, staticRenderFns } from "./ProductPanelSetting.vue?vue&type=template&id=a425b16a&scoped=true"
import script from "./ProductPanelSetting.vue?vue&type=script&lang=js"
export * from "./ProductPanelSetting.vue?vue&type=script&lang=js"
import style0 from "./ProductPanelSetting.vue?vue&type=style&index=0&id=a425b16a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a425b16a",
  null
  
)

export default component.exports